// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__EmbeddedLoader__embeddedLoader{height:inherit;min-height:inherit;min-width:inherit;width:inherit}", "",{"version":3,"sources":["webpack://./../../../../../src/microFrontendSide/integration/lifecycleIntegration/EmbeddedLoader/EmbeddedLoader.module.scss","webpack://./../../platform/@jutro/micro-frontends/microFrontendSide/integration/lifecycleIntegration/EmbeddedLoader/EmbeddedLoader.module.css"],"names":[],"mappings":"AAAA,qCAEE,cAAA,CADA,kBAAA,CAEA,iBAAA,CACA,aCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"embeddedLoader": "jut__EmbeddedLoader__embeddedLoader"
};
export default ___CSS_LOADER_EXPORT___;
